<template>
  <v-container class="d-flex flex-column flex-fill ml-2 mr-4">
    <v-row>
      <v-col cols="12" lg="8">
        <FieldContainer v-if="serverData.organizations" label="Organization">
          <v-autocomplete
            v-model="formData.organization_id"
            clearable
            dense
            outlined
            class="rounded-lg h-50px"
            required
            item-text="text"
            item-value="index"
            :items="serverData.organizations"
            :error-messages="getFieldErrors('organization_id')"
            @blur="touchField('organization_id')"
          ></v-autocomplete>
        </FieldContainer>

        <FieldContainer label="Client type">
          <v-autocomplete
            v-model="formData.type_id"
            clearable
            dense
            outlined
            class="rounded-lg h-50px"
            required
            :items="serverData.client_types"
            item-text="text"
            item-value="index"
            :error-messages="getFieldErrors('type_id')"
            @blur="touchField('type_id')"
          />
        </FieldContainer>

        <FieldContainer label="Program">
          <v-autocomplete
            v-model="formData.partner_id"
            clearable
            item-text="text"
            item-value="index"
            dense
            outlined
            class="rounded-lg h-50px"
            :items="serverData.partners"
          />
        </FieldContainer>

        <FieldContainer label="Subscription plan">
          <v-autocomplete
            v-model="formData.subscription_plan_id"
            clearable
            item-text="text"
            item-value="index"
            dense
            outlined
            class="rounded-lg h-50px"
            :items="serverData.subscription_plans"
            :error-messages="getFieldErrors('subscription_plan_id')"
            @blur="touchField('subscription_plan_id')"
          />
        </FieldContainer>

        <FieldContainer label="Aggregator" v-if="formData.type_id == 1">
          <v-autocomplete
            dense
            outlined
            class="rounded-lg h-50px"
            clearable
            v-model="formData.aggregator_id"
            item-text="text"
            item-value="index"
            :items="serverData.aggregators"
            :error-messages="getFieldErrors('aggregator_id')"
            @blur="touchField('aggregator_id')"
          />
        </FieldContainer>

        <FieldContainer label="Name">
          <v-text-field
            dense
            outlined
            class="rounded-lg h-50px"
            clearable
            v-model="formData.name"
            :error-messages="getFieldErrors('name')"
            @blur="touchField('name')"
          />
        </FieldContainer>

        <FieldContainer label="System code">
          <v-text-field
            dense
            outlined
            class="rounded-lg h-50px"
            clearable
            v-model="formData.systemCode"
            :error-messages="getFieldErrors('systemCode')"
            @blur="touchField('systemCode')"
          />
        </FieldContainer>

        <FieldContainer label="Email">
          <v-text-field
            dense
            outlined
            class="rounded-lg h-50px"
            clearable
            v-model="formData.email"
            :error-messages="getFieldErrors('email')"
            @blur="touchField('email')"
          />
        </FieldContainer>

        <FieldContainer label="Update order status">
          <v-autocomplete
            v-model="formData.update_order_status"
            clearable
            item-text="text"
            item-value="index"
            dense
            outlined
            class="rounded-lg h-50px"
            required
            :items="serverData.statuses"
          />
        </FieldContainer>

        <FieldContainer label="Inventory Flow">
          <v-autocomplete
            v-model="formData.inventory_flow"
            clearable
            item-text="text"
            item-value="index"
            dense
            outlined
            class="rounded-lg h-50px"
            required
            :items="serverData.inventory_flows"
          />
        </FieldContainer>

        <FieldContainer label="Inventory Sync">
          <v-autocomplete
            v-model="formData.inventory_sync"
            clearable
            item-text="text"
            item-value="index"
            dense
            outlined
            class="rounded-lg h-50px"
            required
            :items="serverData.inventory_sync_options"
          />
        </FieldContainer>

        <FieldContainer label="Inventory validation">
          <v-autocomplete
            v-model="formData.inventory_validation"
            clearable
            item-text="text"
            item-value="index"
            dense
            outlined
            class="rounded-lg h-50px"
            required
            :items="serverData.inventory_validation_options"
            :error-messages="getFieldErrors('inventory_validation')"
            @blur="touchField('inventory_validation')"
          />
        </FieldContainer>

        <DatepickerContainer label="Won date">
          <SingleDatepicker
            position="left"
            :value="formData.won_date"
            :clearDate="() => cleardate('won_date')"
            @on-submit="(date) => getDateRange(date, 'won_date')"
            class="poppins"
          />
        </DatepickerContainer>

        <DatepickerContainer label="License expiry date">
          <SingleDatepicker
            position="left"
            :value="formData.license_expiry_date"
            :clearDate="() => cleardate('license_expiry_date')"
            @on-submit="(date) => getDateRange(date, 'license_expiry_date')"
            class="poppins"
            :max-date="null"
            :isByDefaultNextYear="true"
          />
        </DatepickerContainer>

        <FieldContainer label="Staff account limit" :divider="true">
          <v-text-field
            dense
            outlined
            class="rounded-lg h-50px"
            clearable
            v-model="formData.staff_account_limit"
            :error-messages="getFieldErrors('staff_account_limit')"
            @blur="touchField('staff_account_limit')"
          />
        </FieldContainer>

        <!--        <FieldContainer label="Shop name">-->
        <!--          <v-text-field-->
        <!--            v-model="formData.shopName"-->
        <!--            dense-->
        <!--            class="rounded-lg h-50px"-->
        <!--            required-->
        <!--            persistent-hint-->
        <!--            outlined-->
        <!--            clearable-->
        <!--            :error-messages="getFieldErrors('shopName')"-->
        <!--            @blur="touchField('shopName')"-->
        <!--          />-->
        <!--        </FieldContainer>-->

        <!--        <FieldContainer label="Shop code">-->
        <!--          <v-text-field-->
        <!--            v-model="formData.shopCode"-->
        <!--            dense-->
        <!--            class="rounded-lg h-50px"-->
        <!--            required-->
        <!--            persistent-hint-->
        <!--            outlined-->
        <!--            clearable-->
        <!--            :error-messages="getFieldErrors('shopCode')"-->
        <!--            @blur="touchField('shopCode')"-->
        <!--          />-->
        <!--        </FieldContainer>-->

        <FieldContainer label="Shipping label">
          <v-text-field
            v-model="formData.shipping_label_name"
            dense
            class="rounded-lg h-50px"
            required
            persistent-hint
            outlined
            clearable
            :error-messages="getFieldErrors('shipping_label_name')"
            @blur="touchField('shipping_label_name')"
          />
        </FieldContainer>

        <FieldContainer label="Customer offering type">
          <v-autocomplete
            v-model="formData.offer_type_id"
            dense
            :items="serverData.client_offer_types"
            class="rounded-lg h-50px"
            required
            persistent-hint
            outlined
            clearable
            item-text="text"
            item-value="index"
            hide-details
          ></v-autocomplete>
        </FieldContainer>

        <FieldContainer label="Fulfillment type" :divider="true">
          <v-autocomplete
            v-model="formData.fulfillment_types"
            :items="serverData.fulfillment_types"
            clearable
            dense
            multiple
            outlined
            class="rounded-lg h-50px"
            required
            item-text="text"
            item-value="index"
            hide-details
          />
        </FieldContainer>

        <!--        <FieldContainer label="Syncing WMS platform">-->
        <!--          <v-autocomplete-->
        <!--            dense-->
        <!--            outlined-->
        <!--            class="rounded-lg h-50px"-->
        <!--            clearable-->
        <!--            v-model="formData.syncing_wms_platform_id"-->
        <!--            item-text="text"-->
        <!--            item-value="index"-->
        <!--            :items="serverData.syncing_platforms"-->
        <!--          />-->
        <!--        </FieldContainer>-->

        <FieldContainer label="MRSAL code">
          <v-text-field
            v-model="formData.mrsal_code"
            clearable
            dense
            outlined
            hide-details
            class="rounded-lg h-50px"
          />
        </FieldContainer>
        <FieldContainer
          label="MRSAL entity"
          v-if="
            formData.mrsal_code !== null &&
            formData.mrsal_code !== '' &&
            formData.mrsal_code !== undefined
          "
        >
          <v-text-field
            v-model="formData.mrsal_entity"
            clearable
            dense
            outlined
            hide-details
            class="rounded-lg h-50px"
          />
        </FieldContainer>
        <DatepickerContainer
          label="MRSAL expiry"
          v-if="
            formData.mrsal_code !== null &&
            formData.mrsal_code !== '' &&
            formData.mrsal_code !== undefined
          "
        >
          <SingleDatepicker
            position="left"
            :value="formData.mrsal_expiry"
            :clearDate="() => cleardate('mrsal_expiry')"
            @on-submit="(date) => getDateRange(date, 'mrsal_expiry')"
            class="poppins"
            :max-date="null"
          />
        </DatepickerContainer>

        <FieldContainer label="Import/Export Activity Allowed">
          <v-switch
            class="h-55px"
            v-model="formData.is_import_export_activity_allowed"
            inset
            dense
            :true-value="1"
            :false-value="0"
          />
        </FieldContainer>

        <FieldContainer label="RVP pickup schedule modes">
          <v-autocomplete
            v-model="formData.rvp_pickup_scheduled_mode"
            :items="serverData.rvp_pickup_scheduled_modes"
            item-text="text"
            item-value="index"
            dense
            outlined
            hide-details
          />
        </FieldContainer>

        <FieldContainer label="Instant AWB">
          <v-switch
            class="h-55px"
            v-model="formData.instant_awb"
            inset
            dense
            :true-value="1"
            :false-value="0"
          />
        </FieldContainer>

        <FieldContainer label="Instant RVP AWB generation">
          <v-switch
            class="h-55px"
            v-model="formData.instant_rvp_awb"
            inset
            dense
            :true-value="1"
            :false-value="0"
          />
        </FieldContainer>

        <FieldContainer label="Consider base SKU price">
          <v-switch
            class="h-55px"
            v-model="formData.consider_base_sku_price"
            inset
            dense
            :true-value="1"
            :false-value="0"
          />
        </FieldContainer>

        <FieldContainer label="Release on hold order due to out of stock">
          <v-switch
            class="h-55px"
            v-model="formData.auto_release_on_hold_out_of_stock"
            inset
            dense
            :true-value="1"
            :false-value="0"
          />
        </FieldContainer>

        <FieldContainer label="Services">
          <v-autocomplete
            v-model="formData.services"
            :items="serverData.services"
            item-text="text"
            item-value="index"
            dense
            outlined
            multiple
            hide-details
          />
        </FieldContainer>
        <FieldContainer label="Photo" :divider="true">
          <v-file-input
            v-model="formData.photo"
            show-size
            dense
            outlined
            class="rounded-lg h-50px"
            clearable
            accept="image/png, image/jpeg, image/bmp"
            append-icon="mdi-camera"
            prepend-icon=""
            hide-details
          />
        </FieldContainer>
        <FieldContainer label="Logo">
          <v-file-input
            v-model="formData.logo"
            show-size
            dense
            outlined
            class="rounded-lg h-50px"
            clearable
            accept="image/png, image/jpeg, image/bmp"
            append-icon="mdi-camera"
            prepend-icon=""
            hide-details
          />
        </FieldContainer>

        <FieldContainer label="Box calculation based on">
          <v-autocomplete
            v-model="formData.box_calculation_is_based_on"
            dense
            outlined
            class="rounded-lg h-50px"
            required
            :items="serverData.box_calculation"
            item-text="text"
            item-value="index"
            :error-messages="getFieldErrors('box_calculation_is_based_on')"
            @blur="touchField('box_calculation_is_based_on')"
          />
        </FieldContainer>
        <FieldContainer
          label="SKU count in box"
          v-if="formData.box_calculation_is_based_on == 1"
        >
          <v-text-field
            v-model="formData.sku_count_in_box"
            clearable
            dense
            outlined
            type="number"
            min="0"
            class="rounded-lg h-50px"
            :error-messages="getFieldErrors('sku_count_in_box')"
            @blur="touchField('sku_count_in_box')"
          />
        </FieldContainer>

        <FieldContainer label="Description">
          <v-text-field
            dense
            outlined
            class="rounded-lg h-50px"
            clearable
            hide-details
            v-model="formData.description"
          />
        </FieldContainer>

        <FieldContainer label="Sales person">
          <v-autocomplete
            dense
            outlined
            class="rounded-lg h-50px"
            clearable
            multiple
            v-model="formData.sales"
            :items="serverData.sales"
            item-text="text"
            item-value="index"
            hide-details
          />
        </FieldContainer>
        <FieldContainer label="Account manager">
          <v-autocomplete
            dense
            outlined
            multiple
            class="rounded-lg h-50px"
            clearable
            v-model="formData.account_managers"
            :items="serverData.account_managers"
            item-text="text"
            item-value="index"
            hide-details
          />
        </FieldContainer>
        <FieldContainer label="Expiry pullout threshold" :divider="false">
          <v-text-field
            dense
            outlined
            class="rounded-lg h-50px"
            type="number"
            hide-details
            v-model="formData.expiry_pullout_threshold"
          />
        </FieldContainer>
        <FieldContainer label="Temperature control">
          <v-autocomplete
            v-model="formData.temperature_control"
            clearable
            dense
            outlined
            class="rounded-lg h-50px"
            required
            item-value="index"
            item-text="text"
            :items="serverData.temperature_controls"
          />
        </FieldContainer>
        <FieldContainer label="Packing SOP">
          <v-text-field
            dense
            outlined
            class="rounded-lg h-50px"
            type="text"
            hide-details
            v-model="formData.packing_sop"
          />
        </FieldContainer>

        <FieldContainer label="Number of pickups per day">
          <v-autocomplete
            v-model="formData.number_of_pickups_per_day"
            dense
            outlined
            class="rounded-lg h-50px"
            required
            item-value="index"
            item-text="text"
            :items="serverData.number_of_pickups_per_day"
          />
        </FieldContainer>

        <div class="w-100">
          <WMSWarehouseDatatable
            ref="wmsWarehouse"
            :actionItem="actionItem"
            :wmses="serverData.wmes || []"
            :warehouses="serverData.warehouses || []"
            :wms_warehouses="serverData.wms_warehouses || []"
          />
        </div>
      </v-col>
    </v-row>

    <v-row class="mt-10 mb-16">
      <v-col cols="12" lg="8" class="pr-0">
        <v-row class="d-flex justify-content-end">
          <v-col cols="auto">
            <button
              @click="submit"
              type="submit"
              class="btn btn-info px-5 py-3"
            >
              Submit
            </button>
          </v-col>
        </v-row></v-col
      ></v-row
    >
  </v-container>
</template>

<script>
import Swal from "sweetalert2";
import { required, email, numeric, requiredIf } from "vuelidate/lib/validators";

import { SET_ITEM_FOR_ACTION } from "@/core/services/store/main.module";

import fieldValueValidation from "@/own/mixins/fieldValueValidation.js";
import validationMixin from "@/own/mixins/validationMixin.js";
import ApiService from "@/core/services/api.service";
import FieldContainer from "@/own/components/customers/clients/FormParts/FieldContainer.vue";
import DatepickerContainer from "@/own/components/customers/clients/FormParts/DatepickerContainer.vue";
import SingleDatepicker from "@/own/components/SingleDatepicker.vue";
import WMSWarehouseDatatable from "@/own/components/customers/clients/FormParts/WMSWarehouseDatatable/WMSWarehouseDatatable.vue";

export default {
  name: "BasicFormFields",
  mixins: [validationMixin, fieldValueValidation],
  components: {
    WMSWarehouseDatatable,
    FieldContainer,
    SingleDatepicker,
    DatepickerContainer,
  },
  props: ["serverData", "pageLoader", "actionItem", "refresher"],
  validations() {
    return {
      formData: {
        systemCode: { required },
        name: { required },
        // shopCode: { required },
        // shopName: { required },
        shipping_label_name: { required },
        email: { required, email },
        subscription_plan_id: { required },
        staff_account_limit: { required, numeric },
        type_id: { required },
        aggregator_id: {
          required: requiredIf(function () {
            this.formData.type_id === 1;
          }),
        },
        organization_id: {
          required: requiredIf(function () {
            return !!this.serverData.organizations;
          }),
        },
        spl_integration_type: {
          required: requiredIf(function () {
            return !!this.isOrganizationSPL;
          }),
        },
        sku_count_in_box: {
          required: requiredIf(function () {
            return this.formData.box_calculation_is_based_on == 1;
          }),
        },
        box_calculation_is_based_on: { required },
        inventory_validation: { required },
      },
    };
  },
  data() {
    return {
      formData: {
        type_id: 1,
        aggregator_id: null,
        organization_id: null,
        name: null,
        // system_code: null,
        // shopName: null,
        email: null,
        partner_id: null,
        subscription_plan_id: 1,
        update_order_status: null,
        shopCode: null,
        shipping_label_name: null,
        contract_number: null,
        offer_type_id: null,
        sales: [],
        default_warehouse_id: null,
        photo: null,
        logo: null,
        description: null,
        fulfillment_types: [5],
        rvp_pickup_scheduled_mode: 0,
        mrsal_code: null,
        instant_awb: 0,
        instant_rvp_awb: 0,
        consider_base_sku_price: 0,
        systemCode: null,
        won_date: this.today(),
        license_expiry_date: this.today(true),
        sales_person: null,
        account_managers: null,
        services: [16],
        expiry_pullout_threshold: 14,
        packing_sop: null,
        number_of_pickups_per_day: 1,
        box_calculation_is_based_on: 1,
        sku_count_in_box: 1,
        is_import_export_activity_allowed: 0,
        temperature_control: null,
        mrsal_expiry: null,
        mrsal_entity: null,
        // syncing_wms_platform_id: null,
        inventory_flow: 2,
        inventory_validation: 0,
        inventory_sync: 1,
        staff_account_limit: 5,
        auto_release_on_hold_out_of_stock: 0,
      },
      services: 0,
    };
  },
  methods: {
    dateFormatter(date, charForJoin = "-") {
      return [
        date.getFullYear(),
        date.getMonth() + 1 > 9
          ? date.getMonth() + 1
          : `0${date.getMonth() + 1}`,
        date.getDate() > 9 ? date.getDate() : `0${date.getDate()}`,
      ].join(charForJoin);
    },
    today(isByDefaultNextYear = false) {
      const d = new Date();
      if (isByDefaultNextYear) {
        d.setFullYear(d.getFullYear() + 1); // [!code ++] // Shifts the date to next year
      }
      return this.dateFormatter(d);
    },
    submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.pageLoader(true);

        let url = `/authorizations/clients/${
          this.actionItem ? `update` : `store`
        }`;
        // Refactored to use buildFormData
        const data = this.buildFormData();

        ApiService.post(url, data)
          .then(({ data }) => {
            if (data.success) {
              if (data.customer) {
                this.$store.commit(SET_ITEM_FOR_ACTION, data.customer);
              }
              Swal.fire({
                title: this.actionItem ? "Updated" : "Created",
                text: "Successfully submitted",
                icon: "success",
                showConfirmButton: true,
              });
              this.refresher();
            } else {
              let editedItemMessage = `<div><ol>`;
              data.messages.forEach((item) => {
                editedItemMessage += `<li>${item}</li>`;
              });
              editedItemMessage = editedItemMessage + `</ol></div>`;
              Swal.fire({
                title: "Success",
                html: `${editedItemMessage}`,
                icon: data.error_orders === 0 ? "success" : "warning",
                showConfirmButton: true,
                // timer: 2500,
              });
            }
          })
          .then(() => {
            this.reset();
            this.$emit("toggleModal");
          })
          .finally(() => {
            this.pageLoader(false);
          });
      }
    },
    getFormData() {
      Object.entries(this.serverData?.customer).forEach(([key, value]) => {
        this.$set(this.formData, key, value);
      });
      if (this.serverData.customer?.logo) {
        this.formData.logo = new File([""], this.serverData.customer.logo, {
          type: "text/plain",
        });
      }
      if (this.serverData.customer?.photo) {
        this.formData.photo = new File([""], this.serverData.customer.photo, {
          type: "text/plain",
        });
      }
      if (this.serverData.customer?.services.includes(4)) {
        this.services = 1;
      }
      // Populate WMS Warehouses datatable
      if (
        this.$refs.wmsWarehouse &&
        this.serverData.customer?.wms_warehouses?.length
      ) {
        const result = [];
        const lookup = {};

        for (const { wms_id, warehouse_id } of this.serverData.customer
          .wms_warehouses) {
          // If the wms_id group hasn't been created yet
          if (!lookup[wms_id]) {
            lookup[wms_id] = { wms_id, warehouse_id: [] };
            result.push(lookup[wms_id]); // Directly push the object reference to the final array
          }

          // Prevent duplicate warehouse entries inside the loop
          if (!lookup[wms_id].warehouse_id.includes(warehouse_id)) {
            lookup[wms_id].warehouse_id.push(warehouse_id);
          }
        }
        this.$refs.wmsWarehouse.setItems(result || []);
      }
    },
    reset() {
      this.$v?.$reset();
      this.services = 0;
      this.formData = {
        type_id: 1,
        aggregator_id: null,
        organization_id: null,
        name: null,
        // system_code: null,
        // shopName: null,
        email: null,
        partner_id: null,
        subscription_plan_id: 1,
        update_order_status: null,
        shopCode: null,
        shipping_label_name: null,
        contract_number: null,
        offer_type_id: null,
        sales: [],
        default_warehouse_id: null,
        photo: null,
        logo: null,
        description: null,
        fulfillment_types: [5],
        rvp_pickup_scheduled_mode: 0,
        mrsal_code: null,
        instant_awb: 0,
        instant_rvp_awb: 0,
        consider_base_sku_price: 0,
        systemCode: null,
        won_date: this.today(),
        license_expiry_date: this.today(true),
        sales_person: null,
        account_managers: null,
        services: [16],
        expiry_pullout_threshold: 14,
        packing_sop: null,
        number_of_pickups_per_day: 1,
        box_calculation_is_based_on: 1,
        sku_count_in_box: 1,
        is_import_export_activity_allowed: 0,
        temperature_control: null,
        mrsal_expiry: this.today(),
        mrsal_entity: null,
        // syncing_wms_platform_id: null,
        inventory_flow: 2,
        inventory_validation: 0,
        inventory_sync: 1,
        staff_account_limit: 5,
        auto_release_on_hold_out_of_stock: 0,
      };
      // Reset WMS Warehouses datatable
      if (this.$refs?.wmsWarehouse) {
        this.$refs.wmsWarehouse.resetToDefaultValues();
      }
    },
    getDateRange(date, field) {
      if (date && field) {
        this.formData[field] = date[0];
      }
    },
    cleardate(field) {
      if (field) {
        this.formData[field] = null;
      }
    },
    buildFormData() {
      const data = new FormData();

      // 1. Append regular fields
      Object.entries(this.formData).forEach(([key, value]) => {
        // Skip specialized file handling for now (handled separately or selectively)
        if (["image", "photo", "logo", "wms_warehouses"].includes(key)) return;
        // Skip null/undefined/empty string, but allow 0
        const isValidValue =
          (value !== null && value !== undefined && value !== "") ||
          value === 0;

        if (isValidValue) {
          if (Array.isArray(value)) {
            value.forEach((it) => data.append(`${key}[]`, it));
          } else {
            data.append(key, value);
          }
        }
      });

      // 2. Append File fields (logo, photo)
      this.appendFile(
        data,
        "logo",
        this.formData.logo,
        this.serverData.customer?.logo
      );
      this.appendFile(
        data,
        "photo",
        this.formData.photo,
        this.serverData.customer?.photo
      );

      // 3. Append WMS Warehouse entries (flat: one object per warehouse)
      // Sent as JSON string to avoid bracket-notation parsing issues with FormData
      const wmsItems = this.$refs.wmsWarehouse
        ? this.$refs.wmsWarehouse.getItems()
        : [];
      const wmsWarehouses = [];
      wmsItems.forEach((entry) => {
        (entry.warehouse_id || []).forEach((whId) => {
          wmsWarehouses.push({ wms_id: entry.wms_id, warehouse_id: whId });
        });
      });
      wmsWarehouses.forEach((row, i) => {
        data.append(`wms_warehouses[${i}][wms_id]`, row.wms_id);
        data.append(`wms_warehouses[${i}][warehouse_id]`, row.warehouse_id);
      });

      // 4. Append Action Item ID
      if (this.actionItem) {
        data.append("id", this.actionItem.id);
        data.append("tab_name", "basic");
      }

      // 5. Services are appended in step 1 from the autocomplete; send an
      // empty value only when all were cleared so the backend can reset them
      if (!this.formData.services?.length) {
        data.append("services", "");
      }

      return data;
    },
    appendFile(data, key, fileObj, serverUrl) {
      if (fileObj && (fileObj instanceof File || fileObj instanceof Blob)) {
        // Check if it's our mock file
        const isMockFile = fileObj.size === 0 && fileObj.name === serverUrl;

        if (!isMockFile) {
          data.append(key, fileObj);
        }
      } else if (Array.isArray(fileObj) && fileObj[0]) {
        // Legacy support
        data.append(key, fileObj[0]);
      }
    },

    /**
     * Returns validation error messages for a field driven by fields_config.
     * Falls back to empty array when the field has no Vuelidate rule.
     * @param {string} fieldName
     */
    getFieldErrors(fieldName) {
      if (!this.$v.formData || !this.$v.formData[fieldName]) return [];
      return this.handleFormValidation(fieldName, this);
    },
    /**
     * Touches a Vuelidate field on blur (for dynamic fields_config fields).
     * @param {string} fieldName
     */
    touchField(fieldName) {
      if (this.$v.formData && this.$v.formData[fieldName]) {
        this.$v.formData[fieldName].$touch();
      }
    },
  },

  computed: {
    divisions() {
      if (this.serverData.organizations) {
        return this.serverData.organizations.find(
          (item) => item.index === this.formData.organization_id
        )?.divisions;
      } else return [];
    },
    isOrganizationSPL() {
      return (
        this.$store.getters.currentUser.data.organization_system_code === "SPL"
      );
    },
  },
};
</script>

<style></style>
